export default __webpack_public_path__ + "static/media/SPONSOR-Ambassador.9f1904f9.svg";